import React from 'react';

const DetailTable = ({details}) => {
    return (
        <div className="table3-box">
            {
                details?<div dangerouslySetInnerHTML={{__html:details.content}}></div>:null
            }
        </div>
    );
};

export default DetailTable;